
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingFormBaseV2.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingCopyForm, ProjectWizardV2 } from "../../_loadingHelpers/VAMv2";
import { VAM2types, VAMselectEntityDialogModes } from "../../_loadingHelpers/VAMv2Types";
import "../../../moreCore/UI/Floating/Menu";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Edit from '../../../moreCore/UI/Edit/Edit';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialog } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { FeatureHelpers, ToasterHelpers } from "../../../more/Helpers";
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
class EvBookingFormBaseV2 extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
	templateString: any = template;

    sectionLocation: HTMLElement;
    private formContainer: HTMLElement;
    private showIfDatesAreSet: HTMLElement;

    isFullTime_container: HTMLElement;

    private dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;

    private isEmploymentCheckbox: MdsLax<InstanceType<typeof CheckBox>>;

    private cbCreateAutomaticEvProject: MdsLax<InstanceType<typeof CheckBox>>;
    private sectionCreateAutomaticEvProject: HTMLElement;

    private evProjectInput: MdsLax<InstanceType<typeof HintBox>>;
    private bookingTitleInput: MdsLax<InstanceType<typeof Edit>>;

    private activityStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private bookingStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;

    private existingEntity: VAM2types.EvBooking_Base = null;

    private _defaultProjectTimeoutHandler: any = null;

    private isEmployment_container: HTMLDivElement;
    private isConfirmedByOrchestra_container: HTMLDivElement;

    private isEmploymentChoir_container: HTMLDivElement;
    private isEmploymentChoirCheckbox: MdsLax<InstanceType<typeof CheckBox>>;

    afterSetData() {
        let data = this.sourceData as VAM2types.EvBooking_Base;

        if (data.ID) {
            this.webPrivilegeManager.loadPrivilegesForEntity(data, lang.hitch(this, this._onPrivilegesLoaded));
            this.existingEntity = data;


        } else {
            this._onPrivilegesLoaded();
        }

        this.setStylesBasedOnData();

        if (FeatureHelpers.hasFeature("EvBooking/CreateAutomaticEvProject")) {
            let hasProject = this.getAttributeValue("has_project");
            if (hasProject) {
                this.cbCreateAutomaticEvProject.setReadonly(true);
                this.hideNode(this.cbCreateAutomaticEvProject);
            }


            if (!this.entityId && !hasProject) {
                if (FeatureHelpers.hasFeature("EvBooking/PreselectCreateAutomaticEvProject")) {
                    this.cbCreateAutomaticEvProject.setValue(true);
                }
                else {
                    this.cbCreateAutomaticEvProject.setValue(false);
                }
            }
        }
    }

    private setStylesBasedOnData() {
        let data = this.currentData as VAM2types.EvBooking_Base;

        //this.disableNode(this.showIfDatesAreSet, !data.date_start || !data.date_end); // einfach lassen, muss sowieso ausgefüllt werden

        if (this.hasFeature("EvBooking/CreateAutomaticEvProject")) this.hideNode(this.sectionCreateAutomaticEvProject, !!this.entityId);

        this.dateStartInput.useTimeInput(!data.is_full_time, new Date(null, null, null, 0, 0, 0));
        this.dateEndInput.useTimeInput(!data.is_full_time, new Date(null, null, null, 23, 59, 59));
    }

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen
    }

    private _onChange_CbAutomaticEvProject() {
        let bAutomaticEvProject = this.cbCreateAutomaticEvProject.getValue();
        if (!FeatureHelpers.hasFeature("EvBooking/CreateAutomaticEvProject")) {
            bAutomaticEvProject = false;
        }
        if (this.existingEntity) bAutomaticEvProject = false;

        this.disableNode(this.evProjectInput, bAutomaticEvProject == true);
        this.evProjectInput.setMandatory(bAutomaticEvProject != true);

        this.setAttributeValue("ref_ev_project", null);
    }

    private _onChanged_EvBookingName(key: string, newValue: string, oldValue: string) {
        if (newValue) {
            this.emit("displayname", newValue);
        }
    }

    private _onChanged_EvRoom(key: string, newValue: VAM2types.EvRoomEntity, oldValue: any) {
        if (newValue) {

        }
    }
    private _onChanged_EvActivityStatus(key: string, newValue: VAM2types.EvRoomEntity, oldValue: any) {
        if (newValue) {

            if (this.hasUserRole(["OM", "EvBooking_OM"])) {
                this.isEmploymentCheckbox.setValue(newValue.is_employment);
            }
        }
    }
    private _onChanged_FullTime(key: string, newValue: VAM2types.EvRoomEntity, oldValue: any) {
        this.setStylesBasedOnData();

    //    this._onChanged_Dates("date_start", this.currentData.date_start);
    //    this._onChanged_Dates("date_end", this.currentData.date_end);
    }

    _onChanged_Dates(key: string, newDate: Date, oldDate?: Date) {
        let data = this.currentData as VAM2types.EvBooking_Base;

        let dateEnd = this.dateEndInput.getValue()?.date;
        let dateStart = this.dateStartInput.getValue()?.date;

        if (key == "date_start" && dateStart) {

            if (dateStart && oldDate && dateEnd) {
                let diff = dateStart.valueOf() - oldDate.valueOf();

                if (this.hasFeature("EvBooking/DisableDateEndCalculation")) {
                    diff = 0;
                }

                dateEnd = new Date(dateEnd.valueOf() + diff);
                this.dateEndInput.setValue(dateEnd);
            } else if (dateStart && !dateEnd) {
                this.dateEndInput.setValue(dateStart);
            }
        }

        else if (key == "date_end") {
            if (dateEnd && dateStart) {
                let diff = dateEnd.valueOf() - dateStart.valueOf();

                if (diff < 0) {
                    // Ende liegt vor Start. darf nicht sein.
                    this.dateEndInput.setValue(dateStart);
                }
            }

            if (!dateStart) {
                this.dateStartInput.setValue(dateEnd);
            }
        }

        if (this.hasFeature("EvBooking/DefaultProjectByDate") && !this.entityId) {

            this.handleDefaultProjectSelection(dateStart);
        }

        this.setStylesBasedOnData();
    }

    private handleDefaultProjectSelection(dateStart: Date) {

        if (this._defaultProjectTimeoutHandler != null) clearTimeout(this._defaultProjectTimeoutHandler);

        this._defaultProjectTimeoutHandler = setTimeout(
            () => {
                this.RequestManager.callfunction(
                    "Webtool_API_EvBooking__DefaultProject_GetEvProjectValue",
                    { dateStart: dateStart },
                    (response: any) => {
                        //this.evProjectInput.setValue(response[0]);
                        this.setAttributeValue("ref_ev_project", response[0]);
                    },
                    (err: any) => {
                        this.showToast(err.Message, ToasterHelpers.ToasterIcons.error);
                        this.evProjectInput.setValue(null);
                    }
                )
            },
            250
        );
    }

    private _onChangeAudienceSeatingLayoutInput(value?: any) {
        //console.debug("_onChangeAudienceSeatingLayoutInput", value);
    }
    private _onClick_OpenProjectSED(evt) {

        let newCallback = null;
        if (this.hasFeature("EvProject/ProjectWizard") && this.hasUserRole(["Projects_Create", "Projects_Edit"])) {
            newCallback = lang.hitch(this, this._onSelect_CreateNewEvProject);
        }

        this.loadSelectEntityDialog(evt,
            VAMselectEntityDialogModes.evProject,
            lang.hitch(this, this._onCallback_Dlg),
            newCallback
        );
    }
    private _onCallback_Dlg(mode: string, data, items) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        if (!items?.length) return;

        let entity = {
            ID: items[0].entry.value, gDisp_1: items[0].entry.label
        }

        if (mode == "selectEvProject") {
            this.evProjectInput.setValue(entity)
        }

        //this.previousSEDvalue = items;
    }

    private _onSelect_CreateNewEvProject(selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<VAM2types.EvProjectEntity_Base>>>) {
        let projectWizard = new ProjectWizardV2();

        let dlg = new GenericDialog();

        dlg.addNodeToContent(projectWizard.domNode);
        dlg.keepOpen = true;
        dlg.destroyOnClose = false;

        on(projectWizard, "saved", lang.hitch(this, this._onProjectWizardSaved, dlg, projectWizard));
        on(projectWizard, "saveComplete", lang.hitch(this, this._onProjectWizardSaved, dlg, projectWizard));

        dlg.show(null, this.translations["Projects__CreateNew"], null, null, "saveclose", lang.hitch(this, this._onProjectWizardDlgResult, dlg, projectWizard));

        projectWizard.setStartupState("ready");
        projectWizard.startup();
    }

    private _onProjectWizardDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, projectWizard: MdsLax<InstanceType<typeof ProjectWizardV2>>, result: number) {
        if (result >= 1) { // OK/JA
            // speicherversuch
            projectWizard.save();
            dlg.disableAllButtons();
            setTimeout(lang.hitch(dlg, dlg.disableAllButtons, false), 10000); // unschön, aber falls was is, einen save-Error bekommen wir nicht mit...
        } else {
            dlg.close(-1, true);
        }
    }

    private _onProjectWizardSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>, projectWizard: MdsLax<InstanceType<typeof ProjectWizardV2>>) {
        let projectID = projectWizard.getEntityId();
        let displayname = projectWizard.getDisplayname();

        dlg.close(-1);

        let tmpEntity = {};
        tmpEntity[this.evProjectInput.valueAttribute] = projectID;
        tmpEntity[this.evProjectInput.labelAttribute] = displayname;


        this.evProjectInput.setValue(tmpEntity);
    }

    private setupHintboxes() {
        this.evProjectInput.addInlineButton(lang.hitch(this, this._onClick_OpenProjectSED));

    }

    private _onPrivilegesLoaded() {
        // alle Rechte des Entities sind jetzt geladen, d.h. wir können synchron auswerten
        // falls wir hier sind obwohl this.existingEntity leer ist, dann wird die Rolle gewöhnlich allgemeingültig abgefragt
        let editPriv = this.hasUserRole("EvBooking_Edit", null, this.existingEntity);
        let deletePriv = this.hasUserRole("EvBooking_Delete", null, this.existingEntity);
        let evCastPriv = this.hasUserRole("EvBooking_EvCast", null, this.existingEntity);
        let evProgramPriv = this.hasUserRole("EvBooking_EvProgram", null, this.existingEntity);

        this.hideNode(this.isEmployment_container, !this.hasUserRole(["OM", "EvBooking_OM"]));
        this.hideNode(this.isConfirmedByOrchestra_container, !this.hasUserRole(["OM", "EvBooking_OM"]));
    }

    private _autofillEvBookingName(city: string): void {
        if (!this.hasFeature("EvBooking/EvBookingNameCityPrefix")
            || this.entityId
            || !city
            || !this.bookingTitleInput) return;

        let currentValue = this.bookingTitleInput.getValue();

        this.showToast({
            title: `Möchten Sie dem Buchungsnamen die Stadt (${city}) voranstellen?`,
            options: {
                buttons: [{
                    label: "Ja",
                    callback: () => {
                        this.bookingTitleInput.setValue(`${city}: ${currentValue ? currentValue : ""}`);
                    }
                }, {
                    label: "Nein",
                    callback: () => { }
                }]
            },
            ID: "namePrefixToast",
            timeout: "permanent"
        });
    }



    protected afterReady() {
        //this.activityStatusInput.autosetSingleValue("strict");
        //this.bookingStatusInput.autosetSingleValue("strict");
        // manchmal erkennt die Statefulsection bei einem neuen Entity das Autoset nicht als Change!
        // hier ganz furchtbar mit Timeout (Timeouts sind immer furchtbar) kurz warten:
        var activityStatusInput = this.activityStatusInput;
        var bookingStatusInput = this.bookingStatusInput;
        setTimeout(function () {
            activityStatusInput.autosetSingleValue("strict");
            bookingStatusInput.autosetSingleValue("strict");
        }, 250);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupHintboxes();

        this.addOnchanged("date_start", lang.hitch(this, this._onChanged_Dates));
        this.addOnchanged("date_end", lang.hitch(this, this._onChanged_Dates));
        this.addOnchanged("ev_booking_name", lang.hitch(this, this._onChanged_EvBookingName));
        this.addOnchanged("ref_ev_activity_status", lang.hitch(this, this._onChanged_EvActivityStatus));
        this.addOnchanged("ref_ev_room", lang.hitch(this, this._onChanged_EvRoom));
        this.addOnchanged("is_full_time", lang.hitch(this, this._onChanged_FullTime));


        if (this.hasFeature("EvBooking/CreateAutomaticEvProject")) {
            this.hideNode(this.sectionCreateAutomaticEvProject, false);
        }

        if (this.hasFeature("EvBooking/NoIsFullTimeCheckbox")) this.UiModder.domClass.add(this.isFullTime_container, "w3-hide w3-disable");
        if (this.hasFeature("EvBooking/DefaultProjectByDate")) {
            this.evProjectInput.setReadonly(true);
            this.evProjectInput.set("placeholder", this.translate("EvBookingditor_evProject_DefaultProjectInputPlaceholder"));
            this.on("defaultProject_presetBooking", lang.hitch(this, this.handleDefaultProjectSelection));
        }
        if (this.hasFeature("EvBooking/EvBookingNameCityPrefix")) {
            topic.subscribe("EvBookingNameCityPrefix_Changed_EvRoom", lang.hitch(this, this._autofillEvBookingName));
        }

        if (!this.hasFeature("EvBooking/Choir")) {
            //this.isEmploymentChoirCheckbox.destroy();
            this.UiModder.domConstruct.destroy(this.isEmploymentChoir_container);
        }

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingFormBaseV2);
